export const En = {
    l1: 'Sign in',
    l2: 'Home',
    l3: 'Durable Sticker',
    l4: 'Matte Sticker',
    l5: 'Glossy Sticker',
    'Transparent Sticker No Span': 'Transparent Sticker',
    'Budget Sticker No Span': 'Budget Sticker',
    l6: 'Quick Order',
    l7: 'Contact Us',
    l8: '<span>Durable</span> <span class="ml-5">Sticker</span>',
    l9: '<span>Matte</span> <span class="ml-5">Sticker</span>',
    l10: '<span>Glossy</span> <span class="ml-5">Sticker</span>',
    'Transparent Sticker': '<span>Transparent</span> <span class="ml-5">Sticker</span>',
    'Budget Sticker': '<span>Budget</span> <span class="ml-5">Sticker</span>',
    l11: 'Samples',
    l12: 'Quick Order',
    l13: 'Entrepouch',
    l14: 'FAQ',
    l15: 'TERMS & CONDITIONS',
    l16: 'PRIVACY POLICY',
    l18: 'Contact',
    l19: 'Shop Now',
    l20: 'Sign In',
    l21: 'Remember password',
    l22: 'WITH GOOGLE',
    l23: 'WITH FACEBOOK',
    l24: 'Please type in a valid email address',
    l25: 'Please type in at least 8 characters long for your password',
    l26: 'My Account',
    l27: 'Sign Out',
    l28: 'Not a member yet?',
    l29: 'Sign Up',
    l30: 'Already a member?',
    l31: 'Sign In',
    l32: 'Your first name is required',
    l33: 'Your last name is required',
    l34: 'The third-party account has no associated email address, so you can not complete the account registration.',
    l35: 'Custom Stickers',
    l36: 'No product found',
    l37: 'Forgot Password',
    l38: 'Reset Password',
    l39: 'A reset code has been sent to your email address. Please copy and paste below to update your password.',
    l40: 'Please copy and paste the code that was sent to your email address',
    l41: 'It seems that the code was invalid, please check your email message for the code',
    l42: 'Your password was been successfully change.',
    l43: 'Your cart is empty!',
    l44: 'Add items to your cart.',
    l45: 'Your artwork was uploaded.',
    l46: 'Cannot get cart.',
    l47: 'Added to cart successfully',
    l48: 'Upload Your Artwork',
    l49: '<span class="fw-800">Note:</span> Please upload high resolution file (300 dpi). Suggested file types: ai, pdf, psd and jpeg (high resolution). File should be in CMYK color mode.',
    // l50: 'UPLOAD A FILE',
	"Upload A File": 'UPLOAD A FILE',
    l51: 'skip this step and upload artwork later',
    l52: 'or',
    l53: 'Choose file...',
    l54: 'Instructions (optional)',
    l55: 'CONTINUE',
    l56: 'Uploading...',
    l57a: 'Cart',
    l57: 'Order Summary',
    l58: 'Order Number',
    l59: 'Shipping',
    l60: 'Shipping Method',
    l61: 'Shipping Information',
    l62: 'Payment Method',
    l63: 'Subtotal',
    l64: 'Your previous orders are listed below. Click the order to see the details below.',
    l65: 'Add to Cart',
    l66: 'The email address you entered is not existing.',
    l67: 'Password do not match.',
    
    l1b: 'Cart',
    l2b: 'Uses',
    l3b: 'Create an Account',
    l4b: 'Placed Order Successfully!',
    l5b: 'Thank you for ordering. We received your order and will begin processing soon.',
  
    lors1: 'Order Confirmed',
    lorsm1: 'We have received your order. Please wait for the artwork approval. We will inform you once ready.',
    lors2: 'Artwork Approval',
    lorsm2: 'Please approve the artwork(s) by clicking REVIEW ARTWORK button below.',
    lors3: 'Waiting for Payment',
    lorsm3: 'Please settle the complete payment and upload the deposit slip.',
    lors4: 'Payment Verification',
    lorsm4: 'Please give us 24-hours to verify your payment.',
    lors5: 'In-Production',
    lorsm5: 'Your order(s) is now lined-up in the production. We will inform you when labels are shipped.',
    lors6: 'Shipped',
    lors7: 'On Hold',
    lorsm6: 'Your order has been shipped. Tracking Number:',
    lorsm6_2: 'Click the link below to view shipment status:',
    l64a: 'Item successfully updated.',
    l65a: 'Check Out',
    l66a: 'continue shopping',
    l67a: 'Description',
    l68a: 'Quantity',
    l69a: 'Total',
    l70a: 'Add more items to your cart and save.',
    l71a: 'We provide additional discount for ordering 10,000 pcs. & above. The more you order, the more you save.',
    l72a: 'Shipping Information',
    l73a: 'First Name',
    l74a: 'Last Name',
    l75a: 'Street Address',
    l76a: 'City',
    l77a: 'State/Province',
    l78a: 'Zip/Postal Code',
    l79a: 'Mobile Number',
    l80a: 'Shipping Method',
    l81a: 'Delivery Method',
    l82a: 'Cost',
    l83a: 'Payment Method',
    l84a: '*You will not be charged until artwork is approved.',
    l85a: '*Payment can no longer be refunded once payment has been made.',
    l86a: 'Place Order',
    l87a: 'Ship to different address',
    l88a: 'back to your list of orders',
    l89a: 'Order Status',
    l90a: 'Cannot fetch messages',
    l91a: 'You\'ve just approved the artwork',
    l92a: 'You can now proceed to make payment',
    l93a: 'Please tell us something why you want cancel you order',
    l94a: 'Your cancellation request was saved, and will be reviewed by the admin',
    l95a: 'Order was already canceled',
    l96a: 'Canceled',
    l97a: 'Payment Instructions',
    l98a: 'Instructions',
    l99a: 'Total payment of',
    l100a: 'Upload Payment Proof',
    l101a: 'Choose file',
    l102a: 'Confirm',
    l103a: 'Company',
    l104a: 'You have just re-added an item to your cart',
    l105a: 'Please upload your artwork',
    l106a: 'We are still editing your layout, please wait for us to upload your design',
    l107a: 'We accept order minimum qty of 10 pcs',
    l108a: 'Please upload your artwork by clicking the UPLOAD ARTWORK button below.',
    l109a: 'Continue to PayMaya',
    "Trusted by": "Trusted by:",
	"A customer with the same email address already exists. Please try different email and try again.": "A customer with the same email address already exists. Please try different email and try again.",
	"{email} is not a valid email address.": "{email} is not a valid email address.",
    l110a: 'Your change order request was saved, and will be reviewed by the admin',
    l111a: 'Cannot save change order request',
}